import { render, staticRenderFns } from "./RequiredForm.vue?vue&type=template&id=26b5d86a&scoped=true&"
import script from "./RequiredForm.vue?vue&type=script&lang=js&"
export * from "./RequiredForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5d86a",
  null
  
)

export default component.exports